import React from 'react';
import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import { Block } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Card sx={{ textAlign: 'center', maxWidth: 420, p: 2 }}>
        <CardContent>
          <Block sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
          <Typography variant="h5" gutterBottom>Access Denied</Typography>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            You do not have permission to view this page. Contact your administrator to request access.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/dashboard')}>Go to Dashboard</Button>
        </CardContent>
      </Card>
    </Box>
  );
}
